<template>
  <div>
    <!-- 单按钮弹窗 -->
    <div class="Special_popup" :style="{ display: modelShow ? 'block' : 'none' }">
      <div class="box activity-status" :class="brand === 'COTTI' ? 'bg' : ''">
        <div v-if="brand === '茶猫'" class="bg-tc-title"></div>
        <div :class="brand == 'COTTI' ? 'bg-cotti' : 'bg1-tc' ">
          <div class="Special_title" :style="brand == 'COTTI' ? {marginTop: '174px'} : {}">{{ modelTitle }}</div>
          <div :class="brand == 'COTTI' ? 'Special_btn_rqyl' : 'Special_btn_rqyl-tc'" @click="closeModelShow()">
            <div>{{ modelBtnStr }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 成功弹窗 -->
    <div class="Special_popup" :style="{ display: modelSuccessShow ? 'block' : 'none' }">
      <div class="box" :class="brand === 'COTTI' ? 'bg' : ''">
        <div v-if="brand === '茶猫'" class="bg-tc-title"></div>
        <div :class="brand == 'COTTI' ? 'bg-cotti' : 'bg1-tc' ">
          <div class="Special_title" :style="brand == 'COTTI' ? {marginTop: '154px'} : {}">{{ modelSuccessTitle }}</div>
          <div :class="brand == 'COTTI' ? 'Special_btn_rqyl' : 'Special_btn_rqyl-tc'" @click="closeModelSuccessShow()">
            <div>{{ modelSuccessBtnStr }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 双按钮弹窗 -->
    <div class="Special_popup" :style="{ display: twoBtnModelShow ? 'block' : 'none' }">
      <div class="box bg" :class="brand === 'COTTI' ? 'bg' : ''">
        <div v-if="brand === '茶猫'" class="bg-tc-title"></div>
        <div :class="brand == 'COTTI' ? 'bg-cotti' : 'bg1-tc' ">
          <div class="Special_title" :style="brand == 'COTTI' ? {marginTop: '164px'} : {}">{{ twoBtnModeTitle }}</div>
          <div :class="brand == 'COTTI' ? 'Special_btn' : 'Special_btn_tc'">
          <div @click="leftClick">{{ twoBtnModeBtnStr[0] }}</div>
          <div @click="rightClick">{{ twoBtnModeBtnStr[1] }}</div>
        </div>
        </div>
      </div>
    </div>

    <!-- 社群加入弹窗 -->
    <div class="Special_popup" :style="{ display: ispopup ? 'block' : 'none' }">
      <div class="box " :class="brand === 'COTTI' ? 'bg' : ''">
        <div v-if="brand === '茶猫'" class="bg-tc-title"></div>
        <div :class="brand == 'COTTI' ? 'bg-cotti' : 'bg1-tc' ">
          <div class="Special_title" :style="brand == 'COTTI' ? {'margin-top': '164px'} : {'margin-top': '1px'}">加入{{ brandName }}「福利社群」后才可领取哦～</div>
          <div :class="brand == 'COTTI' ? 'Special_btn' : 'Special_btn_tc'">
          <div @click="popup_del">取消</div>
          <div @click="goCommunity">立即加入</div>
        </div>
        </div>
      </div>
    </div>

    <!-- 规则弹窗 -->
    <div class="Special_popup" :style="{ display: openRule ? 'block' : 'none' }">
      <div class="box">
        <div :class="brand == 'COTTI' ? 'rule_top' : 'rule_teacat_top'"></div>
        <div :class="brand == 'COTTI' ? 'bg1' : 'bg1-tc'">
          <div v-if="brand == 'COTTI'" class="Special_content_bg"></div>
          <div class="Special_content_ly">
            <div class="Special_content" v-html="contentFormatter"></div>
          </div>
        </div>
        <img class="icon-close" src="../../../assets/ticket/close-icon.png" @click.stop="doCloseRule">
      </div>
    </div>

    <!-- 入群有礼弹窗 -->
    <div class="Special_popup" :style="{ display: isGroupGift ? 'block' : 'none' }">
      <div class="box" :class="brand === 'COTTI' ? 'bg' : ''">
        <div v-if="brand === '茶猫'" class="bg-tc-title"></div>
        <div v-if="brand === '茶猫'" class="bg1-tc">
          <div class="Special_title" style="margin-top: 30px;">{{ groupGiftTitle }}</div>
          <div class="Special_btn_rqyl-tc" @click="groupGiftClick">
            我知道了
            <div v-if="goApplet_1" style="position: absolute; width: 100%; height: 100%; top: 0">
              <wx-open-launch-weapp :username="originalAppId" path="pages/index/index"
                style="width: 100%; height: 100%; opacity: 0; display: block">
                <script type="text/wxtag-template">
                  <div>打开{{ brandName }}小程序</div>
                  <div>打开{{ brandName }}小程序</div>
                  <div>打开{{ brandName }}小程序</div>
                </script>
              </wx-open-launch-weapp>
            </div>
          </div>
        </div>
        <div v-if="brand === 'COTTI'" class="Special_title" style="margin-top: 174px;">{{ groupGiftTitle }}</div>
        <div v-if="brand === 'COTTI'" class="Special_btn_rqyl" @click="groupGiftClick">
          我知道了
          <div v-if="goApplet_1" style="position: absolute; width: 100%; height: 100%; top: 0">
            <wx-open-launch-weapp :username="originalAppId" path="pages/index/index"
              style="width: 100%; height: 100%; opacity: 0; display: block">
              <script type="text/wxtag-template">
                <div>打开{{ brandName }}小程序</div>
                <div>打开{{ brandName }}小程序</div>
                <div>打开{{ brandName }}小程序</div>
              </script>
            </wx-open-launch-weapp>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PopupContainer',
  props: {
    // 品牌相关
    brand: {
      type: String,
      required: true
    },
    brandName: {
      type: String,
      default: 'Cotti'
    },
    // 单按钮弹窗
    modelShow: {
      type: Boolean,
      default: false
    },
    modelTitle: {
      type: String,
      default: ''
    },
    modelBtnStr: {
      type: String,
      default: ''
    },
    // 成功弹窗
    modelSuccessShow: {
      type: Boolean,
      default: false
    },
    modelSuccessTitle: {
      type: String,
      default: ''
    },
    modelSuccessBtnStr: {
      type: String,
      default: ''
    },
    // 双按钮弹窗
    twoBtnModelShow: {
      type: Boolean,
      default: false
    },
    twoBtnModeTitle: {
      type: String,
      default: ''
    },
    twoBtnModeBtnStr: {
      type: Array,
      default: () => ['', '']
    },
    // 社群加入弹窗
    ispopup: {
      type: Boolean,
      default: false
    },
    // 规则弹窗
    openRule: {
      type: Boolean,
      default: false
    },
    contentFormatter: {
      type: String,
      default: ''
    },
    // 入群有礼弹窗
    isGroupGift: {
      type: Boolean,
      default: false
    },
    groupGiftTitle: {
      type: String,
      default: ''
    },
    goApplet_1: {
      type: Boolean,
      default: false
    },
    originalAppId: {
      type: String,
      default: ''
    },
    // 活动数据
    activityData: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    // 双按钮弹窗左侧点击
    leftClick() {
      this.$emit('leftClick');
    },
    // 双按钮弹窗右侧点击
    rightClick() {
      this.$emit('rightClick');
    },
    // 关闭社群弹窗
    popup_del() {
      this.$emit('popupDel');
    },
    // 去社群
    goCommunity() {
      this.$emit('goCommunity');
    },
    // 关闭规则弹窗
    doCloseRule() {
      this.$emit('closeRule');
    },
    // 入群有礼点击
    groupGiftClick() {
      this.$emit('groupGiftClick');
    },
    // 关闭弹窗
    closeModelShow() {
      this.$emit('closeModelShow');
    },
    // 关闭成功弹窗
    closeModelSuccessShow() {
      this.$emit('closeModelSuccessShow');
    }
  }
};
</script>

<style scoped lang="scss">
$button-bg-color: #A52337;
$text-color: #D77C43;
$tip-bg-color: #CF4744;
 .Special_popup {
    background: rgba(0, 0, 0, 0.5);
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    z-index: 9999;

    .box {
      overflow: hidden;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      z-index: 10;

      .rule_top {
        width: 606px;
        height: 136px;
        background-image: url(https://cdn-arch-common-prod.cotticoffee.com/cottih5/open-rule-top-1.png);
        background-size: 100% 100%;
      }
      .rule_teacat_top {
         width: 606px;
        height: 116px;
        background-image: url('~@/assets/ticket/title-top.png');
         background-size: 100% 100%;
      }

      .Special_title {
        width: 86%;
        color: var(--coupon-toast-color);
        font-size: 32px;
        text-align: center;
        font-weight: 600;
        font-family: PingFangSC-Medium, sans-serif;
        white-space: pre-wrap;
      }

      .Special_content_bg {
        width: 396px;
        height: 422px;
        // background-image: url('../../assets/ticket/open-rule-bg.png');
        background-size: 100% 100%;
        position: absolute;
        right: 0;
        bottom: 0;
        z-index: 1;
      }

      .Special_content_ly {
        width: 542px;
        max-height: 620px;
        margin-left: 12px;
        overflow-y: auto;
        z-index: 2;
      }

      .Special_content {
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: var(--coupon-toast-color);
        line-height: 40px;
        text-align: left;
        word-break: break-all;
        margin-top: 16px;
      }

      .Special_btn {
        position: absolute;
        display: flex;
        box-sizing: border-box;
        bottom: 64px;
        font-size: 32px;

        >div:nth-child(1) {
          width: 198px;
          height: 80px;
          border: 2px #cfcfcf solid;
          border-radius: 6px;
          overflow: hidden;
          background: #fff;
          line-height: 80px;
          text-align: center;
          margin-right: 24px;
          color: #868686;
        }

        >div:nth-child(2) {
          width: 320px;
          height: 80px;
          border-radius: 6px;
          overflow: hidden;
          background: var(--primary-color);
          line-height: 80px;
          text-align: center;
          color: #fff;
        }
      }


      .Special_btn_tc {
        position: absolute;
        display: flex;
        box-sizing: border-box;
        bottom: 64px;
        font-size: 32px;

        >div:nth-child(1) {
          width: 160px;
          height: 80px;
          border: 1px #2A2A2A solid;
          border-radius: 40px;
          overflow: hidden;
          background: #fff;
          line-height: 80px;
          text-align: center;
          margin-right: 24px;
          color: var(--text-color);
        }

        >div:nth-child(2) {
          width: 350px;
          height: 80px;
          border-radius: 40px;
          border: 1px #2A2A2A00 solid;
          overflow: hidden;
          background: linear-gradient(135deg, #FF883A 0%, #FF2B2B 100%);
          line-height: 80px;
          text-align: center;
          color: #fff;
        }
      }

      .Special_btn_singal {
        position: absolute;
        bottom: 64px;
        height: 80px;
        width: 530px;
        box-sizing: border-box;
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;
        -webkit-box-pack: center;
        -webkit-justify-content: center;
        justify-content: center;
        -webkit-box-align: center;
        -webkit-align-items: center;
        align-items: center;

        background-color: $button-bg-color;
        font-size: 32px;
        font-weight: 500;
        color: #fff;
        line-height: 44px;

        border-radius: 6px;
      }

      .Special_btn_rqyl {
        height: 80px;
        background: $button-bg-color;
        box-sizing: border-box;
        -webkit-box-pack: center;
        -webkit-justify-content: center;
        justify-content: center;
        -webkit-box-align: center;
        -webkit-align-items: center;
        align-items: center;
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;
        font-size: 32px;
        font-weight: 550;
        color: #fff;
        line-height: 44px;
        margin: 55px 0;
        width: 530px;
        position: relative;
      }
      .Special_btn_rqyl-tc {
        height: 80px;
        background: linear-gradient(135deg, #FF883A 0%, #FF2B2B 100%);
        box-sizing: border-box;
        -webkit-box-pack: center;
        -webkit-justify-content: center;
        justify-content: center;
        -webkit-box-align: center;
        -webkit-align-items: center;
        align-items: center;
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;
        font-size: 32px;
        font-weight: 550;
        color: #fff;
        line-height: 44px;
        margin: 85px 0 0 0;
        width: 526px;
        border-radius: 40px;
        position: relative;
      }

      .icon-close {
        margin-top: 45px;
        width: 48px;
      }
    }

    .bg {
      width: 606px;
      height: 620px;
      background: url(https://cdn-product-prod.cotticoffee.com/wechat/cotti/images/activity/activity-success.png);
      background-size: 100% auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      border-bottom-left-radius: 12px;
      border-bottom-right-radius: 12px;
    }
    .bg-tc-title {
      width: 606px;
      height: 300px;
      background: url('../../../assets/ticket/tc-top.png');
      background-size: 100% auto;
    }


    .bg-cotti {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .bg1 {
      width: 606px;
      min-height: 250px;
      background-color: #fff;
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      padding: 32px 0;
      border-bottom-left-radius: 20px;
      border-bottom-right-radius: 20px;
    }
    .bg1-tc {
      width: 606px;
      min-height: 220px;
      background-color: #fff;
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      padding: 32px 0;
      border-bottom-left-radius: 24px;
      border-bottom-right-radius: 24px;
    }

    .activity-status {
      width: 606px;
      height: 620px;
      background-image: url(https://cdn-product-prod.cotticoffee.com/wechat/cotti/images/activity/activity-end.png);
      background-size: 100% 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .activity-status-success {
      width: 646px;
      height: 536px;
      background-image: url('../../../assets/ticket/activity-status.png');
      background-size: 100% 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }
</style>